module.exports = __webpack_public_path__ + "media/images/login-images-c348af9cbf4134ad8b0edef4bafc00f1.jpg";